import { HttpClient } from '@angular/common/http';
import { Data, Response, UPSERT, waitAndRetry } from '@dimandzhi/graphql';
import { currentMethodName } from 'app/current-method-name';
import { GraphQL } from 'app/graphql';
import { environment as env } from 'environments/environment';
import _ from 'lodash';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';


type gqlType = GraphQL.UserSchema.Schedule;
const gqlType = GraphQL.UserSchema.Schedule;
const ModelName = gqlType.getModelName();
export class UserSchedules {
  private userSchedulesFirstCall: boolean;
  private userSchedules: BehaviorSubject<gqlType[]>;

  constructor(
    protected http: HttpClient
  ) { }

  initUserSchedules() {
    this.userSchedulesFirstCall = true
    this.userSchedules = new BehaviorSubject<gqlType[]>([]);
  }

  setUserSchedules(schedule: gqlType) {
    let action: UPSERT = 'update';
    if (schedule.id === undefined) {
      action = 'insert';
    }
    let mData = schedule.mutationData();
    return this.http.post<Response>(`${env.graphqlUser}/${currentMethodName()}`, `
      mutation {
        ${ModelName} {
          ${action}(values:[{${mData}}])
        }
      }`
    ).pipe(
      Data.fromResp,
      map(data => {
        const result = _.get(data.get(), `${ModelName}.${action}`);
        if (result === undefined) {
          throw new Error(`result is undefined`);
        }
        return result;
      })
    );
  }

  insertUserSchedules(schedule: gqlType) {
    return this.setUserSchedules(schedule).pipe(
      map(IDs => {
        if (!_.isArrayLike(IDs)) {
          throw new Error(`IDs is not an array: ${typeof IDs} ${IDs}`);
        }
        const id = _.head(IDs);
        if (!_.isNumber(id)) {
          throw new Error(`id is not a number: ${typeof id} ${id}`);
        }
        schedule.id = id;
        // TODO: or full refresh?
        this.userSchedules.next(this.userSchedules.value.concat(schedule));
        return id;
      })
    );
  }

  updateUserSchedules(schedule: gqlType) {
    return this.setUserSchedules(schedule).pipe(
      map(rowsAffected => {
        if (!_.isNumber(rowsAffected)) {
          throw new Error(`rowsAffected is not a number: ${typeof rowsAffected} ${rowsAffected}`);
        }
        if (rowsAffected > 0) {
          //this.channels.next(this.channels.value.concat(channel));
        }
        return rowsAffected;
      })
    );
  }

  deleteUserSchedule(schedule: gqlType) {
    return this.http.post<Response>(`${env.graphqlUser}/${currentMethodName()}`, `
      mutation {
        ${ModelName} {
          delete(values:[${schedule.id}])
        }
      }`
    ).pipe(
      waitAndRetry,
      Data.fromResp,
      map(data => {
        this.userSchedules.next(this.userSchedules.value.filter(s => s.id !== schedule.id));
        return _.get(data.get(), `${ModelName}.delete`);
      })
    );
  }

  getUserSchedules(): Observable<gqlType[]>;
  getUserSchedules(asSnapshot: boolean): gqlType[];
  getUserSchedules(asSnapshot?: boolean) {
    if (this.userSchedulesFirstCall) {
      this.refreshUserSchedules();
      this.userSchedulesFirstCall = false;
    }
    if (asSnapshot) {
      return this.userSchedules.getValue();
    }
    return this.userSchedules.asObservable();
  }

  queryUserSchedulesForChannel(channelID: number) {
    return this.http.post<Response>(`${env.graphqlUser}/${currentMethodName()}`, `
      query {
        ${ModelName}(channelID: ${channelID}) {
          data {
            ${gqlType.fields({ withSubFields: true })}
          }
        }
      }`
    ).pipe(waitAndRetry, Data.fromResp, map(data => gqlType.fromData<gqlType>(data, 'data')));
  }

  refreshUserSchedules() {
    this.http.post<Response>(`${env.graphqlUser}/${currentMethodName()}`, `
      query {
        ${ModelName} {
          data {
            ${gqlType.fields({ withSubFields: true })}
          }
        }
      }`
    ).pipe(waitAndRetry, Data.fromResp).subscribe({
      next: data =>
        this.userSchedules.next(gqlType.fromData(data, 'data')),
      error: err => this.userSchedules.error(err)
    });
  }
}
